import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { imgProps } from "../../lib/api";
import { useLang } from "../../i18n";
import { PRODUCTS, productHref } from "../../data/products";
import { Reveal, Eyebrow } from "../Reveal";

export default function ProductsGrid() {
  const { t, lang } = useLang();
  return (
    <>
      {/* PRODUCTS */}
      <section data-testid="home-products" className="border-t border-[#1C1A17] bg-[#0A0A09]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-36">
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
            <Reveal>
              <Eyebrow>{t.products_eyebrow}</Eyebrow>
              <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F3EFE6]">{t.products_title}</h2>
              <p className="mt-4 max-w-xl text-sm sm:text-base font-light text-[#A39E93] leading-relaxed">{t.products_sub}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <Link to="/prodotti" data-testid="view-all-products-link" className="group inline-flex items-center gap-2 text-sm uppercase tracking-[0.15em] text-[#C8A86B]">
                {t.products_all} <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </Reveal>
          </div>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5 sm:gap-6">
            {PRODUCTS.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.08} className={i === 4 ? "md:col-span-12" : i === 1 || i === 2 ? "md:col-span-7" : "md:col-span-5"}>
                <Link to={productHref(p)} data-testid={`home-product-${p.slug}`} className={`card-float group relative block aspect-[4/5] overflow-hidden ${i === 4 ? "sm:aspect-[21/9]" : "sm:aspect-[4/3]"} border border-[#262420] bg-[#111110]`}>
                  <img {...imgProps(p.image, "(max-width: 768px) 100vw, 50vw")} alt={lang === "it" ? p.name_it : p.name_en} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-85 transition-all [transition-duration:1400ms] ease-out group-hover:scale-105 group-hover:opacity-100 group-hover:brightness-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#080808] via-[#080808]/40 to-transparent" />
                  <span className="absolute left-6 top-6 font-mono text-xs tracking-[0.3em] text-[#C8A86B]">{p.number}</span>
                  <span className="absolute right-6 top-6 flex h-10 w-10 items-center justify-center rounded-full border border-[#C8A86B]/50 text-[#C8A86B] opacity-0 transition-all duration-500 group-hover:opacity-100 group-hover:rotate-45"><ArrowUpRight size={16} /></span>
                  <div className="absolute inset-x-6 bottom-6">
                    <h3 className="font-serif text-2xl sm:text-3xl font-light text-[#F3EFE6]">{lang === "it" ? p.name_it : p.name_en}</h3>
                    <p className="mt-2 text-sm font-light text-[#A39E93]">{lang === "it" ? p.tagline_it : p.tagline_en}</p>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

    </>
  );
}
